import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'acc-docs-editor',
  params: ['namespace', 'kind', 'name'],
});
